import api from '../api'

const moocCategoryProvider = {
  AddCategoryCourse(params) {
    return api.post(`/university/api/AdminCourse/AddCategory`, params)
  },
  updateCategoryCourse(params) {
    return api.put(`university/api/AdminCourse/EditCategory`, params)
  },
  getCategorysCourse(id) {
    return api.get(`/university/api/AdminCourse/GetCategory/id?id=${id}`)
  },
  deleteCategoryCourse(id) {
    return api.delete(`/university/api/AdminCourse/DeleteCategory/${id}`)
  },
  AddCategoryPackage(params) {
    return api.post(`/university/api/AdminPackage/AddCategory`, params)
  },
  updateCategoryPackage(params) {
    return api.put(`university/api/AdminPackage/EditCategory`, params)
  },
  getCategorysPackage(id) {
    return api.get(`/university/api/AdminPackage/GetCategory/id?id=${id}`)
  },
  deleteCategoryPackage(id) {
    return api.delete(`/university/api/AdminPackage/DeleteCategory/${id}`)
  },
}

export default moocCategoryProvider
